<template>
    <div class="h-100 admin-bg-greenlight"> 
        <Toast />

        <div class="hidden lg:flex flex-column h-100" style="min-width: 295px;">
            <div class="text-center">
                <img 
                    :src="require(`../../../assets/images/icons/${imageUrl}`)"
                    style="max-width: 80%;"
                    class="mt-5 mb-3"
                />
            </div>
            <div class="px-3 mb-3">
                <span class="p-input-icon-right w-100">
                    <i  
                        v-if="search"
                        @click="search = ''"
                        style="cursor: pointer"
                        class="pi pi-times" 
                    />
                    <InputText 
                    style="padding-top: 10px; padding-bottom: 10px;" 
                    class="w-100"
                    placeholder="Search..."
                    v-model="search" size="small"
                    autocomplete="new-password" />
                </span>
            </div>
            <div class="flex-grow-1 sidebar-item-container">
                <SidebarItem 
                    v-for="(it) in filteredMenu"
                    class="mb-1"
                    style="font-weight: 500;"
                    :key="it.label"
                    :isOpen="it.isOpen ? it.isOpen : false"
                    :item="it"/>
            </div>
        </div>

        <Sidebar class="lg:hidden admin-bg-greenlight" v-model:visible="showMobileSidebar">
            <template #container>
                <div class="flex align-items-center justify-content-between px-4 pt-3 flex-shrink-0">
                    <img 
                    :src="require(`../../../assets/images/icons/${imageUrl}`)"
                        style="max-width: 40%"
                        class="inline-flex align-items-center gap-2 mb-4"
                    />
                    <span>
                        <Button type="button" @click="toggleMobileSidebar(false)" 
                            icon="pi pi-times" outlined class="h-2rem w-2rem"
                            style="border: none"
                            severity="secondary">
                        </Button>
                    </span>
                </div>
                <div class="px-3 w-100 mb-2">
                    <InputText 
                    class="w-100"
                    style="padding-top: 10px; padding-bottom: 10px" 
                    placeholder="Search..."
                    v-model="search" size="small" />
                </div>
                <div class="flex-grow-1 sidebar-item-container">
                    <SidebarItem 
                        v-for="(it) in filteredMenu"
                        class="mb-1"
                        style="font-weight: 500;"
                        :key="it.label"
                        :isOpen="it.isOpen ? it.isOpen : false"
                        :item="it"/>
                </div>
            </template>
        </Sidebar>
    </div>
</template>


<script>
    import { mapWritableState, mapActions, mapState } from "pinia";
    import { useGeneralStore } from "@/stores/GeneralStore";
    import { useUserStore } from "@/stores/UserStore";
    import Toast from 'primevue/toast';
    // import Tree from 'primevue/tree';
    import Sidebar from 'primevue/sidebar'
    import SidebarItem from '@/views/components/sidebar/SidebarItem.vue'
    import Button from 'primevue/button'
    import InputText from 'primevue/inputtext'

    export default {
        name: "AdminSidebar",
        components: {
            Toast,
            // Tree,
            Sidebar,
            SidebarItem,
            Button,
            InputText,
        },
        data() {
            return {
                expandedKeys: {},
                selectedKey: [],
                search: "",
                allMenu: [],
            }
        },
        computed: { 
            ...mapWritableState( useGeneralStore, ['showMobileSidebar', 'activeOwner']),
            ...mapState( useGeneralStore, ['listMenu']),
            ...mapState(useUserStore, ["user_id", "company_id"]),

            imageUrl() {
                return this.activeOwner.logoFile
            },

            filteredMenu(){
                let menus = []
                this.getAllMenu(this.listMenu);

                if (this.search){
                    menus = this.allMenu.filter(x => x.label.toLowerCase().includes(this.search.toLowerCase()))
                } else {
                    menus = this.listMenu;

                    let currentMenu = this.allMenu.find(x => x.label.toLowerCase() == this.$route.name.toLowerCase());

                    //open all menu if the menu is nested
                    if(currentMenu && currentMenu.id >= 10) {
                        //then the current menu is a child
                        menus = this.openAllParent(menus, currentMenu.id);
                    }
                }

                return menus;
            },
        },
        methods: {
            ...mapActions( useGeneralStore, ['toggleMobileSidebar', 'getListMenu']),

            getAllMenu(nestedMenu){
                const vm = this;

                nestedMenu.forEach(m => {
                    if(!m.children || m.children.length <= 0){
                        let found = vm.allMenu.some(x => x.label === m.label);

                        if(!found){
                            vm.allMenu.push(m);
                        }
                    } else {
                        vm.getAllMenu(m.children)
                    }
                })
            },

            openAllParent(nestedMenu, currentMenuId){
                const vm = this;

                nestedMenu.forEach(m => {
                    if(m.children && m.children.length > 0){
                        if(m.id.toString().charAt(0) == currentMenuId.toString().charAt(0)){
                            m.isOpen = true;
                        } else {
                            m.isOpen = false;
                        }
                        vm.openAllParent(m.children, currentMenuId)   
                    }
                })

                return nestedMenu;
            },

            onNodeSelect(node) {
                this.$toast.add({ severity: 'success', summary: 'Node Selected', detail: node.label, life: 3000 });

                if(node.key != "pages"){
                    this.$router.push({ path: `/admin/${node.key}` })
                }
            },
            onNodeUnselect(node) {
                this.$toast.add({ severity: 'warn', summary: 'Node Unselected', detail: node.label, life: 3000 });
            },
            onNodeExpand(node) {
                this.expandedKeys[node.key] = true;
                this.$toast.add({ severity: 'info', summary: 'Node Expanded', detail: node.label, life: 3000 });
            },
            onNodeCollapse(node) {
                this.expandedKeys[node.key] = false;
                this.$toast.add({ severity: 'error', summary: 'Node Collapsed', detail: node.label, life: 3000 });
            },
            test(node){
                console.log(node)
            }
        },
        mounted(){
            // console.log(this.showMobileSidebar)
            if(this.listMenu.length == 0) {
                const params = {
                    action: "get",
                    user_id : this.user_id,
                    company_id : this.company_id,
                    is_active : 1
                }
                this.getListMenu(params)
            }
        }
    }
</script>
<style scoped>
    ::v-deep a{
        text-decoration: none !important;
    }

    .p-tieredmenu-root-list{
        padding: 0;
    }

    .sidebar-item-container{
        overflow-y: auto;
        max-height: 100% !important;
    }

    /* width */
    ::-webkit-scrollbar {
        width: 5px;
        border-radius: 5px;
    }

    /* Track */
    ::-webkit-scrollbar-track {
        background: transparent;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
        background: var(--primary-color);
        transition: 0.2s;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
        background: var(--secondary-color);
        transition: 0.2s;
    }
</style>